import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Settings2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import PlayListAnalytics from "./PlayListAnalytics";
import PlayListArchive from "./PlayListArchive";
import PlayListTasks from "./PlayListTasks";
import PlayListUpcoming from "./PlayListUpcoming";

export const PlayListDisplay = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full mx-auto">
      <div className="flex justify-end mb-4">
        <Button variant="secondary" onClick={() => navigate("/setup/rules")}>
          <Settings2 className="mr-2 h-4 w-4" />
          Manage
        </Button>
      </div>

      <Tabs defaultValue="tasks" className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="tasks">Tasks</TabsTrigger>
          <TabsTrigger value="archive">Archive</TabsTrigger>
          <TabsTrigger value="upcoming">Upcoming</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>

        <TabsContent value="tasks" className="mt-4">
          <PlayListTasks />
        </TabsContent>

        <TabsContent value="archive" className="mt-4">
          <PlayListArchive />
        </TabsContent>

        <TabsContent value="upcoming" className="mt-4">
          <PlayListUpcoming />
        </TabsContent>

        <TabsContent value="analytics" className="mt-4">
          <PlayListAnalytics />
        </TabsContent>
      </Tabs>
    </div>
  );
};
